<template src='./ComponenteSelect.html'>
</template>
<script>
import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import {serverBus} from '../../main'

Vue.use(VueMaterial)
export default {
  data() {
    return{
      valorSeleccionado:[],
    }
  },
 props: {
    datoSeguimiento: Object,
    index: Number
  },
  methods:{
    seleccionSeguimientos (nombre_campo, index) { 
      const jsonSeleccion = {nombre_campo,'valor':this.valorSeleccionado[index],index}
      serverBus.$emit('jsonSeleccion',jsonSeleccion);   
    } 
  },
};
</script>
<style lang="scss" scoped src='./ComponenteSelect.scss'>
</style>



// WEBPACK FOOTER //
// src/components/ComponenteSelect/ComponenteSelect.vue